import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-page-activity-estimating-monthly-expenses-nancy-rw',
  templateUrl: './page-activity-estimating-monthly-expenses-nancy-rw.component.html',
  styleUrls: ['./page-activity-estimating-monthly-expenses-nancy-rw.component.css','../module-page-rw/module-page-rw.component.css']
})
export class PageActivityEstimatingMonthlyExpensesNancyRwComponent implements OnInit {

  @Input()
  backTitle = 'Back';

  @Input()
  nextTitle = 'Next';

  @Input()
  delay = true;

  @Output()
  back = new EventEmitter<Event>();

  @Output()
  next = new EventEmitter<Event>();

  flag = false;
  checked = false; // compare with keys

  model = {
    housing: {
      row1: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row2: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row3: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row4: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row5: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row6: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row7: { value1: '', value2: '', value3: '', value4: '', value5: '', other: '' },
      row8: { value1: '', value2: '', value3: '', value4: '', value5: '', total: true },
    },
    fab: {
      row1: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row2: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row3: { value1: '', value2: '', value3: '', value4: '', value5: '', other: '' },
      row4: { value1: '', value2: '', value3: '', value4: '', value5: '', total: true },
    },
    caregiving: {
      row1: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row2: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row3: { value1: '', value2: '', value3: '', value4: '', value5: '', other: '' },
      row4: { value1: '', value2: '', value3: '', value4: '', value5: '', total: true },
    },
    transportation: {
      row1: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row2: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row3: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row4: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row5: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row6: { value1: '', value2: '', value3: '', value4: '', value5: '', other: '' },
      row7: { value1: '', value2: '', value3: '', value4: '', value5: '', total: true },
    },
    health: {
      row1: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row2: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row3: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row4: { value1: '', value2: '', value3: '', value4: '', value5: '' },
      row5: { value1: '', value2: '', value3: '', value4: '', value5: '', other: '' },
      row6: { value1: '', value2: '', value3: '', value4: '', value5: '', total: true },
    },
    savings: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '', total: true },
    },
    personal: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '', value2: '', value3: '' },
      row5: { value1: '', value2: '', value3: '' },
      row6: { value1: '', value2: '', value3: '' },
      row7: { value1: '', value2: '', value3: '' },
      row8: { value1: '', value2: '', value3: '' },
      row9: { value1: '', value2: '', value3: '' },
      row10: { value1: '', value2: '', value3: '' },
      row11: { value1: '', value2: '', value3: '', other: '' },
      row12: { value1: '', value2: '', value3: '', total: true },
    },
    recreation: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
      row4: { value1: '', value2: '', value3: '' },
      row5: { value1: '', value2: '', value3: '', other: '' },
      row6: { value1: '', value2: '', value3: '', total: true },
    },
    currentBills: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '', creditor: '' },
      row4: { value1: '', value2: '', value3: '', creditor: '' },
      row5: { value1: '', value2: '', value3: '', creditor: '' },
      row6: { value1: '', value2: '', value3: '', creditor: '' },
      row7: { value1: '', value2: '', value3: '' },
      row8: { value1: '', value2: '', value3: '' },
      row9: { value1: '', value2: '', value3: '', other: '' },
      row10: { value1: '', value2: '', value3: '', total: true },
    },
    overdueBills: {
      row1: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row2: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row3: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row4: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row5: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row6: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row7: { value1: '', value2: '', value3: '', value4: '', value5: '', creditor: '' },
      row8: { value1: '', value2: '', value3: '$140.00', value4: '', value5: '', creditor: '', total: true },
    },
    monthlyIncome: {
      row1: { value1: '$1,020' },
      row2: { value1: '$656' },
      row3: { value1: '$0' },
      row4: { value1: '', total: true },
    },
    monthlyExpense: {
      row1:  { value1: '', total: 'housing.value4'        },
      row2:  { value1: '', total: 'fab.value4'            },
      row3:  { value1: '', total: 'caregiving.value4'     },
      row4:  { value1: '', total: 'transportation.value4' },
      row5:  { value1: '', total: 'health.value4'         },
      row6:  { value1: '', total: 'savings.value4'        },
      row7:  { value1: '', total: 'personal.value2'       },
      row8:  { value1: '', total: 'recreation.value2'     },
      row9:  { value1: '', total: 'currentBills.value2'   },
      row10: { value1: '', total: 'overdueBills.value4'   },
      row11: { value1: '', total: true },
    },
    summary: {
      row1: { value1: '', total: 'monthlyIncome.value1' },
      row2: { value1: '', total: 'monthlyExpense.value1' },
      row3: { value1: '', bottomLine: true },
    }
  };

  keys = {
    housing: {
      row1: { value1: '', value2: '$396', value3: '$99', value4: '$495', value5: ''  },
      row2: { value1: '', value2: '$106', value3: '',    value4: '$106', value5: ''  },
      row3: { value1: '', value2: '$39',  value3: '',    value4: '$39',  value5: ''  },
      row4: { value1: '', value2: '',     value3: '',    value4: '',     value5: ''  },
      row5: { value1: '', value2: '',     value3: '',    value4: '',     value5: ''  },
      row6: { value1: '', value2: '',     value3: '',    value4: '',     value5: ''  },
      row7: { value1: '', value2: '',     value3: '',    value4: '',     value5: '', other: '' },
      row8: { value1: '', value2: '$541', value3: '$99', value4: '$640', value5: ''  },
    },
    fab: {
      row1: { value1: '', value2: '$35', value3: '$278', value4: '$313', value5: ''  },
      row2: { value1: '', value2: '$10', value3: '',     value4: '$10',  value5: ''  },
      row3: { value1: '', value2: '',    value3: '',     value4: '',     value5: '', other: '' },
      row4: { value1: '', value2: '$45', value3: '$278', value4: '$323', value5: ''  },
    },
    caregiving: {
      row1: { value1: '', value2: '$121', value3: '$279', value4: '$400', value5: ''  },
      row2: { value1: '', value2: '',     value3: '',     value4: '',     value5: ''  },
      row3: { value1: '', value2: '',     value3: '',     value4: '',     value5: '', other: '' },
      row4: { value1: '', value2: '$121', value3: '$279', value4: '$400', value5: ''  },
    },
    transportation: {
      row1: { value1: '', value2: '',     value3: '', value4: '',     value5: ''  },
      row2: { value1: '', value2: '$80',  value3: '', value4: '$80',  value5: ''  },
      row3: { value1: '', value2: '$45',  value3: '', value4: '$45',  value5: ''  },
      row4: { value1: '', value2: '',     value3: '', value4: '',     value5: ''  },
      row5: { value1: '', value2: '',     value3: '', value4: '',     value5: ''  },
      row6: { value1: '', value2: '',     value3: '', value4: '',     value5: '', other: '' },
      row7: { value1: '', value2: '$125', value3: '', value4: '$125', value5: '' },
    },
    health: {
      row1: { value1: '', value2: '',    value3: '', value4: '',    value5: ''  },
      row2: { value1: '', value2: '$20', value3: '', value4: '$20', value5: ''  },
      row3: { value1: '', value2: '',    value3: '', value4: '',    value5: ''  },
      row4: { value1: '', value2: '',    value3: '', value4: '',    value5: ''  },
      row5: { value1: '', value2: '',    value3: '', value4: '',    value5: '', other: '' },
      row6: { value1: '', value2: '$20', value3: '', value4: '$20', value5: '' },
    },
    savings: {
      row1: { value1: '', value2: '', value3: '' },
      row2: { value1: '', value2: '', value3: '' },
      row3: { value1: '', value2: '', value3: '' },
    },
    personal: {
      row1:  { value1: '', value2: '$25', value3: ''  },
      row2:  { value1: '', value2: '$12', value3: ''  },
      row3:  { value1: '', value2: '$10', value3: ''  },
      row4:  { value1: '', value2: '',    value3: ''  },
      row5:  { value1: '', value2: '',    value3: ''  },
      row6:  { value1: '', value2: '',    value3: ''  },
      row7:  { value1: '', value2: '',    value3: ''  },
      row8:  { value1: '', value2: '',    value3: ''  },
      row9:  { value1: '', value2: '',    value3: ''  },
      row10: { value1: '', value2: '$8',  value3: ''  },
      row11: { value1: '', value2: '',    value3: '', other: '' },
      row12: { value1: '', value2: '$55', value3: ''  },
    },
    recreation: {
      row1: { value1: '', value2: '$48', value3: ''  },
      row2: { value1: '', value2: '',    value3: ''  },
      row3: { value1: '', value2: '',    value3: ''  },
      row4: { value1: '', value2: '',    value3: ''  },
      row5: { value1: '', value2: '',    value3: '', other: '' },
      row6: { value1: '', value2: '$48', value3: ''  },
    },
    currentBills: {
      row1:  { value1: '', value2: '$18', value3: ''  },
      row2:  { value1: '', value2: '$32', value3: ''  },
      row3:  { value1: '', value2: '',    value3: '', creditor: '' },
      row4:  { value1: '', value2: '',    value3: '', creditor: '' },
      row5:  { value1: '', value2: '',    value3: '', creditor: '' },
      row6:  { value1: '', value2: '',    value3: '', creditor: '' },
      row7:  { value1: '', value2: '',    value3: ''  },
      row8:  { value1: '', value2: '',    value3: ''  },
      row9:  { value1: '', value2: '',    value3: '', other:    '' },
      row10: { value1: '', value2: '$50', value3: ''  },
    },
    overdueBills: {
      row1: { value1: '', value2: '', value3: '',     value4: '$40',  value5: '', creditor: '' },
      row2: { value1: '', value2: '', value3: '',     value4: '$25',  value5: '', creditor: '' },
      row3: { value1: '', value2: '', value3: '',     value4: '$35',  value5: '', creditor: '' },
      row4: { value1: '', value2: '', value3: '',     value4: '$30',  value5: '', creditor: '' },
      row5: { value1: '', value2: '', value3: '',     value4: '$10',  value5: '', creditor: '' },
      row6: { value1: '', value2: '', value3: '',     value4: '',     value5: '', creditor: '' },
      row7: { value1: '', value2: '', value3: '',     value4: '',     value5: '', creditor: '' },
      row8: { value1: '', value2: '', value3: '$140', value4: '$140', value5: '', creditor: '' },
    },
    monthlyIncome: {
      row1: { value1: '$ 1,020' },
      row2: { value1: '$ 656'   },
      row3: { value1: ''       },
      row4: { value1: '$ 1,676' },
    },
    monthlyExpense: {
      row1:  { value1: '$ 640'   },
      row2:  { value1: '$ 323'   },
      row3:  { value1: '$ 400'   },
      row4:  { value1: '$ 125'   },
      row5:  { value1: '$ 20'    },
      row6:  { value1: '$ 0'     },
      row7:  { value1: '$ 55'    },
      row8:  { value1: '$ 48'    },
      row9:  { value1: '$ 50'    },
      row10: { value1: '$ 140'   },
      row11: { value1: '$ 1,801' },
    },
    summary: {
      row1: { value1: '$ 1,676' },
      row2: { value1: '$ 1,801' },
      row3: { value1: '$ -125' },
    },
  }

  correct = JSON.parse(JSON.stringify(this.model)); // clone empty
  correctAll = false;

  previewByAdmin = this.auth.isSuperAdmin;
  // previewByAdmin = false;

  constructor(private auth: AuthService) { }

  ngOnInit(): void {
    // this.check();
    this.calcTotals();
  }

  goBack(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.back.emit(event);
    return true;
  }

  goNext(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.next.emit(event);
    return true;
  }

  setFlag() {
    this.flag = true;
  }

  resetFlag() {
    this.flag = false;
  }

  activityOneCompleted() {
    if (!this.delay) return true;

    const summaryRows = Object.values(this.model.summary);
    return summaryRows.some(r => r.value1 !== '' && r.value1 !== '$0');
  }

  check(event?: Event) {
    if (this.checked) return true;
    if (event?.defaultPrevented) return false;

    const model   = this.model as any;
    const keys    = this.keys as any;
    const correct = this.correct as any;
    const compare = ['value', 'value1', 'value2', 'value3', 'value4', 'value5'];

    this.correctAll = true; // TBD below

    for (const section in model) {
      for (const row in model[section]) {
        const answer = model[section][row];
        const key    = keys[section][row];

        for (const value of compare) {
          if (!(value in answer)) {
            continue;
          }

          const a    = this.parseAmount(answer[value]) || '';
          const k    = this.parseAmount(key[value]) || '';
          const diff = a !== k;

          correct[section][row][value] = diff ? key : '';

          if (diff) {
            this.correctAll = false;
          }

          if (diff && !a) {
            answer[value] = '$0';
          }
        }
      }
    }

    this.checked = true;

    return false;
  }

  calcTotals(): void {
    const model = this.model as any;
    const properties = ['value1', 'value2', 'value3', 'value4', 'value5'];

    for (const section in model) {
      const rows: any[] = Object.values(model[section]);
      const totals = rows.filter(r => r.total);
      const bottomLine = rows.find(r => r.bottomLine);
      const input = rows.filter(r => !r.total && !r.bottomLine);

      // calculate This Month Total Spent	value
      if (['housing', 'fab', 'caregiving', 'transportation', 'health'].includes(section)) {
        for (const row of input) {
          row.value4 = this.formatAmount((+this.parseAmount(row.value2) || 0) + (+this.parseAmount(row.value3) || 0));
        }
      }

      // calculate Total Spent values in table footer
      for (const total of totals) {
        let targetRows = input;
        let targetProperty = '';

        if (typeof total.total === 'string') {
          const [section, prop] = total.total.split('.');
          targetRows = Object.values(model[section] as any[]).filter(r => r.total);
          targetProperty = prop;
        }

        for (const property of properties) {
          if (property in total) {
            total[property] = this.sumAmountsBy(targetRows, targetProperty || property);
          }
        }
      }

      // calculate Bottom Line at the end as a difference between Total Monthly Income and Assistance and Total Monthly Expenses
      if (bottomLine) {
        const value1 = this.parseAmount(totals[0].value1);
        const value2 = this.parseAmount(totals[1].value1);
        bottomLine.value1 = this.formatAmount(+value1 - +value2);
      }
    }
  }

  isNegative(amount: string) {
    return amount && String(amount).startsWith('$-');
  }

  private parseAmount(value: string) {
    if (!value && typeof value !== 'number') return NaN;
    const amount = parseFloat(String(value || '').replace(/[^\d\.]+/g, ''));
    return isNaN(amount) ? amount : amount.toFixed(2);
  }

  private formatAmount(value: string|number) {
    return '$' + Number(value).toLocaleString('en-US');
  }

  private sumAmountsBy(rows: any[], property: string) {
    const total = _(rows).filter(r => r[property]).map(r => +this.parseAmount(r[property]) || 0).sum();
    return this.formatAmount(total);
  }
}
